import React from 'react';
import { PreviewContent } from '../../../../styles/TradeDocStyles';
import { REACT_APP_BASE_URL } from '../../../../config';
import DocumentViewer from '../../../DocumentViewer/DocumentViewer';
import { Stack } from '@mui/material';
import moment from 'moment';
import { formatCurrency, formatNumber } from '../../../../utils/helper';
import { TransformedItems } from '../../../../pages/dashboard/tradedocuments/tradeDocumentTypes/CommercialTypes';

const QuotationPreviewMobile = ({
    data,
    docTitle,
    quoteFields,
    totalAmount,
    signatureUrlBase64
}: {
    data: any;
    docTitle: string;
    quoteFields: TransformedItems[];
    totalAmount?: number;
    signatureUrlBase64: string;
}) => {
    return (
        <PreviewContent style={{ padding: '25px 0' }}>
            <div className='flex items-center justify-start pb-4 mb-4 border-b'>
                {data?.logoUrl ? (
                    <div className='h-[4rem] w-[100%] '>
                        <DocumentViewer
                            fileUrl={`${REACT_APP_BASE_URL}/${data?.logoUrl.split(
                                '/v1/'
                            )[1]}`}
                        />
                    </div>
                ) : (
                    <>
                        <div>
                            <img
                                src='/img/vectors/powered.svg'
                                alt=''
                                className=' h-[50px]'
                            />
                        </div>
                    </>
                )}
            </div>

            <Stack
                direction='column'
                alignItems='start'
                className='top-preview-content'
                width='full'
                gap={2}
                justifyContent={'space-between'}
            >
                {docTitle !== 'Draft Gross Mass Declaration' && (
                    <div className='view-one' style={{ maxWidth: '100%' }}>
                        <p className='font-semibold text-appcolorprimary'>
                            Invoice From
                        </p>
                        <p className='font-medium'>{data?.sellerName}</p>
                        <p>{data?.sellerAddress}</p>
                        <p>{data?.sellerCountry}</p>
                    </div>
                )}
                {docTitle !== 'Draft Gross Mass Declaration' && (
                    <div className='view-two' style={{ maxWidth: '100%' }}>
                        <p className='font-semibold text-appcolorprimary'>
                            Invoice To
                        </p>
                        <p className='font-medium'>{data?.receiverName}</p>
                        <p>{data?.receiverAddress}</p>
                        <p>{data?.receiverCountry}</p>
                    </div>
                )}

                {docTitle === 'Quotation' && (
                    <div
                        className='view-three space-y-2 border-t pt-4'
                        style={{ maxWidth: '100%' }}
                    >
                        <Stack
                            direction='row'
                            gap='20px'
                            width='100%'
                            justifyContent='space-between'
                            style={{ marginBottom: 0 }}
                        >
                            <p className='title'>Quote No.</p>
                            <p className='value'>{data?.quoteNumber || '--'}</p>
                        </Stack>
                        <Stack
                            direction='row'
                            gap='20px'
                            width='100%'
                            justifyContent='space-between'
                        >
                            <p className='title'>Issued Date</p>
                            <p className='value'>
                                {moment(data.issuedDate).format('ll') || '--'}
                            </p>
                        </Stack>
                        <Stack
                            direction='row'
                            gap='20px'
                            width='100%'
                            justifyContent='space-between'
                        >
                            <p className='title'>Port of Loading</p>
                            <p className='value'>
                                {data.portOfLoadingValue?.name || '--'}
                            </p>
                        </Stack>

                        <Stack
                            direction='row'
                            gap='20px'
                            width='100%'
                            justifyContent='space-between'
                        >
                            <p className='title'>Method of Dispatch</p>
                            <p className='value'>
                                {data.methodOfDispatch || '--'}
                            </p>
                        </Stack>

                        <Stack
                            direction='row'
                            gap='20px'
                            width='100%'
                            justifyContent='space-between'
                        >
                            <p className='title'>Port of Discharge</p>
                            <p className='value'>
                                {data.portOfDischargeValue?.name || '--'}
                            </p>
                        </Stack>

                        <Stack
                            direction='row'
                            gap='20px'
                            width='100%'
                            justifyContent='space-between'
                        >
                            <p className='title'>Type of Shipment</p>
                            <p className='value'>
                                {data.typeOfShipment || '--'}
                            </p>
                        </Stack>
                    </div>
                )}

                {docTitle === 'Proforma Invoice' && (
                    <div
                        className='view-three space-y-2 border-t pt-4'
                        style={{ maxWidth: '100%' }}
                    >
                        <Stack
                            direction='row'
                            gap='20px'
                            width='100%'
                            justifyContent='space-between'
                            style={{ marginBottom: 0 }}
                        >
                            <p className='title'>Invoice No.</p>
                            <p className='value'>
                                {data?.invoiceNumber || '--'}
                            </p>
                        </Stack>

                        <Stack
                            direction='row'
                            gap='20px'
                            width='100%'
                            justifyContent='space-between'
                        >
                            <p className='title'>Date</p>
                            <p className='value'>
                                {moment(data.invoiceDate).format('ll') || '--'}
                            </p>
                        </Stack>

                        <Stack
                            direction='row'
                            gap='20px'
                            width='100%'
                            justifyContent='space-between'
                        >
                            <p className='title'>Buyer Reference</p>
                            <p className='value'>
                                {data.buyerReference || '--'}
                            </p>
                        </Stack>

                        <Stack
                            direction='row'
                            gap='20px'
                            width='100%'
                            justifyContent='space-between'
                        >
                            <p className='title'>Port of Loading</p>
                            <p className='value'>
                                {data.portOfLoadingValue?.name || '--'}
                            </p>
                        </Stack>

                        <Stack
                            direction='row'
                            gap='20px'
                            width='100%'
                            justifyContent='space-between'
                        >
                            <p className='title'>Port of Discharge</p>
                            <p className='value'>
                                {data.portOfDischargeValue?.name || '--'}
                            </p>
                        </Stack>

                        <Stack
                            direction='row'
                            gap='20px'
                            width='100%'
                            justifyContent='space-between'
                        >
                            <p className='title'>Method of Dispatch</p>
                            <p className='value'>
                                {data.methodOfDispatch || '--'}
                            </p>
                        </Stack>

                        <Stack
                            direction='row'
                            gap='20px'
                            width='100%'
                            justifyContent='space-between'
                        >
                            <p className='title'>Type of Shipment</p>
                            <p className='value'>
                                {data.typeOfShipment || '--'}
                            </p>
                        </Stack>
                    </div>
                )}

                {docTitle === 'Purchase Order' && (
                    <div
                        className='view-three space-y-2 border-t pt-4'
                        style={{ maxWidth: '100%' }}
                    >
                        <Stack
                            direction='row'
                            gap='20px'
                            width='100%'
                            justifyContent='space-between'
                            alignItems='flex-end'
                            style={{ marginBottom: 0 }}
                        >
                            <p className='title'>Purchase Order No.</p>
                            <p className='value'>
                                {data?.purchaseOrderNumber || '--'}
                            </p>
                        </Stack>
                        <Stack
                            direction='row'
                            gap='20px'
                            width='100%'
                            justifyContent='space-between'
                        >
                            <p className='title'>Issued Date</p>
                            <p className='value'>
                                {moment(data.issuedDate).format('ll') || '--'}
                            </p>
                        </Stack>
                        <Stack
                            direction='row'
                            gap='20px'
                            width='100%'
                            justifyContent='space-between'
                        >
                            <p className='title'>Supplier Reference</p>
                            <p className='value'>
                                {data.supplierReference || '--'}
                            </p>
                        </Stack>

                        <Stack
                            direction='row'
                            gap='20px'
                            width='100%'
                            justifyContent='space-between'
                        >
                            <p className='title'>Shipper Reference</p>
                            <p className='value'>
                                {data.shipperReference || '--'}
                            </p>
                        </Stack>

                        <Stack
                            direction='row'
                            gap='20px'
                            width='100%'
                            justifyContent='space-between'
                        >
                            <p className='title'>Method of Dispatch</p>
                            <p className='value'>
                                {data.methodOfDispatch || '--'}
                            </p>
                        </Stack>

                        <Stack
                            direction='row'
                            gap='20px'
                            width='100%'
                            justifyContent='space-between'
                        >
                            <p className='title'>Type of Shipment</p>
                            <p className='value'>
                                {data.typeOfShipment || '--'}
                            </p>
                        </Stack>

                        <Stack
                            direction='row'
                            gap='20px'
                            width='100%'
                            justifyContent='space-between'
                        >
                            <p className='title'>Port of Loading</p>
                            <p className='value'>
                                {data.portOfLoadingValue?.name || '--'}
                            </p>
                        </Stack>

                        <Stack
                            direction='row'
                            gap='20px'
                            width='100%'
                            justifyContent='space-between'
                        >
                            <p className='title'>Port of Discharge</p>
                            <p className='value'>
                                {data.portOfDischargeValue?.name || '--'}
                            </p>
                        </Stack>
                    </div>
                )}

                {docTitle === 'Draft Gross Mass Declaration' && (
                    <>
                        <div className='view-one ' style={{ maxWidth: '100%' }}>
                            <p className='font-semibold text-appcolorprimary'>
                                Shipper
                            </p>
                            <p className='font-medium'>{data?.shipperName}</p>
                            <p>{data?.shipperAddress}</p>
                            <p>{data?.shipperCountry}</p>
                            <div className='mt-[5px] w-full'></div>
                        </div>
                        <div
                            className='view-three space-y-2 border-t pt-4'
                            style={{ maxWidth: '100%' }}
                        >
                            <Stack
                                direction='row'
                                gap='20px'
                                width='100%'
                                justifyContent='space-between'
                                alignItems='flex-end'
                                style={{ marginBottom: 0 }}
                            >
                                <p className='title'>Shipper Reference.</p>
                                <p className='value'>
                                    {data?.shipperReference || '--'}
                                </p>
                            </Stack>

                            <Stack
                                direction='row'
                                gap='20px'
                                width='100%'
                                justifyContent='space-between'
                                alignItems='flex-end'
                            >
                                <p className='title'>Shipper Address.</p>
                                <p className='value'>
                                    {data?.shipperAddress || '--'}
                                </p>
                            </Stack>

                            <Stack
                                direction='row'
                                gap='20px'
                                width='100%'
                                justifyContent='space-between'
                                alignItems='flex-end'
                            >
                                <p className='title'>Certificate Number.</p>
                                <p className='value'>
                                    {data?.certificateNumber || '--'}
                                </p>
                            </Stack>
                        </div>
                    </>
                )}
            </Stack>

            {docTitle === 'Draft Gross Mass Declaration'
                ? quoteFields?.map((item: any) => (
                      <Stack
                          direction='column'
                          alignItems='start'
                          className='mid-preview-content mt-0 border-t border-dashed bg-aliceBlue'
                          width='full'
                          justifyContent={'space-between'}
                          style={{
                              marginBottom: 0,
                              marginTop: 0,
                              borderStyle: 'dashed'
                          }}
                      >
                          <div
                              className='view-one'
                              style={{ maxWidth: '100%' }}
                          >
                              <div className='flex justify-between'>
                                  <p className='title'>Container No</p>
                                  <p className='value'>
                                      {item.containerNumber}
                                  </p>
                              </div>
                              <div className='flex justify-between'>
                                  <p className='title'>Container Tare (Kg)</p>
                                  <p className='value'>
                                      {formatNumber(item.containerTare)}
                                  </p>
                              </div>
                              <div className='flex justify-between'>
                                  <p className='title'>Cargo Weight (KG) </p>
                                  <p className='value'>
                                      {formatNumber(item.cargoWeight)} Kg{' '}
                                  </p>
                              </div>
                              <div className='flex justify-between'>
                                  <p className='title'>Gross Weight (KG)</p>
                                  <p className='value'>
                                      {formatNumber(item.grossWeight)} Kg{' '}
                                  </p>{' '}
                              </div>
                          </div>
                      </Stack>
                  ))
                : quoteFields?.map((item: any) => (
                      <Stack
                          direction='column'
                          alignItems='start'
                          className='mid-preview-content mt-0 border-t border-dashed bg-aliceBlue'
                          width='full'
                          justifyContent={'space-between'}
                          style={{
                              marginBottom: 0,
                              marginTop: 0,
                              borderStyle: 'dashed'
                          }}
                      >
                          <div
                              className='view-one'
                              style={{ maxWidth: '100%' }}
                          >
                              <div className='flex justify-between'>
                                  <p className='title'>Product Code</p>
                                  <p className='value'>{item.id}</p>
                              </div>
                              <div className='flex justify-between'>
                                  <p className='title'>Description of goods</p>
                                  <p className='value'>{item.desc ?? '--'}</p>
                              </div>
                              <div className='flex justify-between'>
                                  <p className='title'>Quantity </p>
                                  <p className='value'>
                                      {formatNumber(item.qty)}
                                  </p>
                              </div>
                              <div className='flex justify-between'>
                                  <p className='title'>Unit Type </p>
                                  <p className='value'>{item.type ?? '--'}</p>
                              </div>
                              <div className='flex justify-between'>
                                  <p className='title'>Price </p>
                                  <p className='value'>
                                      {formatCurrency(
                                          item.price,
                                          item.currencyCode
                                      )}
                                  </p>
                              </div>
                              <div className='flex justify-between'>
                                  <p className='title'>Total </p>
                                  <p className='value'>
                                      {formatCurrency(
                                          (isNaN(item.price) ? 0 : item.price) *
                                              (isNaN(item.qty) ? 0 : item.qty),
                                          data?.currencyCode
                                      )}
                                  </p>
                              </div>
                          </div>
                      </Stack>
                  ))}

            <Stack direction='row' justifyContent='flex-end'>
                {docTitle === 'Draft Gross Mass Declaration' ? (
                    <div className='w-full flex justify-between border-t border-b border-appcolorprimary py-4'>
                        Total Weight :{' '}
                        <span className=''>
                            {formatNumber(data?.grossWeight || 0)} Kg
                        </span>
                    </div>
                ) : (
                    <div className='w-full flex justify-between border-t border-b border-appcolorprimary py-4'>
                        Total amount :{' '}
                        <span className=''>
                            {formatCurrency(
                                totalAmount || 0,
                                data?.currencyCode
                            )}
                        </span>
                    </div>
                )}
            </Stack>

            <Stack
                direction='column'
                alignItems='start'
                className='bottom-preview-content'
                width='full'
                justifyContent={'space-between'}
                style={{
                    position: 'static',
                    marginTop: 0,
                    paddingLeft: 0,
                    paddingRight: 0
                }}
            >
                <div
                    className='view-one space-y-2'
                    style={{ maxWidth: '100%' }}
                >
                    {docTitle === 'Proforma Invoice' && (
                        <div className='w-[100%] mb-[15px]'>
                            <p className='titl'>Bank Details</p>
                            <Stack
                                direction='row'
                                gap='20px'
                                width='100%'
                                justifyContent='space-between'
                            >
                                <p className=''>Bank Name</p>
                                <p className='value'>
                                    {data.sellerBankName || '--'}
                                </p>
                            </Stack>

                            <Stack
                                direction='row'
                                gap='20px'
                                width='100%'
                                justifyContent='space-between'
                            >
                                <p className='w-[6rem]'>Account No.</p>
                                <p className='value'>
                                    {data.sellerAccountNumber || '--'}
                                </p>
                            </Stack>

                            <Stack
                                direction='row'
                                gap='20px'
                                width='100%'
                                justifyContent='space-between'
                            >
                                <p className='w-[6rem]'>Swift Code</p>
                                <p className='value'>
                                    {data.sellerSwiftCode || '--'}
                                </p>
                            </Stack>
                        </div>
                    )}
                    <div>
                        <p className='titl'>Additional Information</p>
                        <p>{data?.additionalInformation || '--'}</p>
                    </div>
                </div>

                <div
                    className='view-two space-y-2 mt-2'
                    style={{ maxWidth: '100%' }}
                >
                    <div>
                        <p className='titl'>Place of Issue</p>
                        <p className=''>{data?.placeOfIssue || '--'}</p>
                    </div>
                    <div>
                        <p className='titl'>Signatory Company</p>
                        <p>{data?.signatoryCompany || '--'}</p>
                    </div>

                    {data?.stamp && (
                        <Stack direction='row' justifyContent='flex-start'>
                            <div className='totalView w-[250px]'>
                                <p className='titl'>Stamp</p>
                                <div className='h-50px] '>
                                    <DocumentViewer
                                        fileUrl={`${REACT_APP_BASE_URL}/${data?.stamp.split(
                                            '/v1/'
                                        )[1]}`}
                                    />
                                </div>
                            </div>
                        </Stack>
                    )}
                </div>

                <div
                    className='view-three space-y-2 mt-2'
                    style={{ maxWidth: '100%' }}
                >
                    <div>
                        <p className='titl'>Date of Issue</p>
                        <p className=''>
                            {moment(data.dateOfIssue).format('ll') || '--'}
                        </p>
                    </div>
                    <div>
                        <p className='titl'>Name of Authorized Signatory</p>
                        <p>{data?.nameOfAuthorisedSignatory || '--'}</p>
                    </div>
                    <div>
                        <p className='titl'>Signature</p>
                        <img src={`${signatureUrlBase64}`} alt='' />
                    </div>
                </div>
            </Stack>
        </PreviewContent>
    );
};

export default QuotationPreviewMobile;
